// src/pages/JourneyMap/components/JourneyStepper.jsx
import React from 'react';
import { UserIcon, PaintBrushIcon, PencilSquareIcon, RocketLaunchIcon, ChartBarIcon, CheckIcon } from '@heroicons/react/24/outline';

export const JOURNEY_STEPS = [
  { id: 'perfil',   icon: UserIcon,          label: 'Perfil'   },
  { id: 'criacao',  icon: PaintBrushIcon,    label: 'Criação'  },
  { id: 'refino',   icon: PencilSquareIcon,  label: 'Refino'   },
  { id: 'turbinar', icon: RocketLaunchIcon,  label: 'Turbinar' },
  { id: 'vendas',   icon: ChartBarIcon,      label: 'Vendas'   },
];

const ORDER = JOURNEY_STEPS.map(s => s.id);

export function stepIndex(status) {
  const i = ORDER.indexOf(status);
  return i === -1 ? 0 : i;
}

export default function JourneyStepper({ currentStatus }) {
  const currentIdx = stepIndex(currentStatus);

  return (
    <nav className="jm-stepper" aria-label="Progresso da jornada">
      {JOURNEY_STEPS.map((step, idx) => {
        const isDone   = idx < currentIdx;
        const isActive = idx === currentIdx;
        const cls = `jm-step ${isDone ? 'done' : ''} ${isActive ? 'active' : ''}`;

        return (
          <div key={step.id} className={cls} aria-current={isActive ? 'step' : undefined}>
            <div className="jm-step__circle">
              {isDone ? <CheckIcon style={{width:14,height:14}} /> : <step.icon style={{width:16,height:16}} />}
            </div>
            <span className="jm-step__label">{step.label}</span>
          </div>
        );
      })}
    </nav>
  );
}
